(function () {
  'use strict';

  const CLONE_COUNT = 3;
  const parsePrice = (val) => parseFloat((val || '').replace(/[₹,]/g, '')) || 0;

  document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('[data-reel-carousel]');
    if (!wrapper) return;

    const loaderHTML = document.querySelector('[data-rc-loader]')?.innerHTML ?? '';

    const track = wrapper.querySelector('[data-rc-track]');
    if (!track) return;

    const navPrev = wrapper.querySelector('[data-rc-prev]');
    const navNext = wrapper.querySelector('[data-rc-next]');
    const skeleton = wrapper.querySelector('[data-rc-skeleton]');

    const modalStyle = wrapper.dataset.modalStyle ?? 'single';

    let currentIndex = 0;
    let allCards = [];
    let totalReal = 0;
    let isTransitioning = false;
    let modalMuted = true;

    const modal = { open: openModal, close: closeModal };

    // Keep clones out of the keyboard/AT flow without `inert` — inert also
    // blocks pointer events, which killed the swatch/ATC on the clone cards
    // shown at the carousel edges. aria-hidden + tabindex=-1 preserves the
    // a11y intent while letting clicks through.
    const prepClone = (card) => {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('button, a[href], input, select, textarea, [tabindex]').forEach((el) => {
        el.setAttribute('tabindex', '-1');
      });
      clone.removeAttribute('id');
      return clone;
    };

    const cloneEdges = (realCards) => {
      for (let i = totalReal - 1; i >= totalReal - CLONE_COUNT; i--) {
        track.insertBefore(prepClone(realCards[i]), track.firstChild);
      }
      for (let i = 0; i < CLONE_COUNT; i++) {
        track.appendChild(prepClone(realCards[i]));
      }
    };

    const calcOffset = (index) => {
      const containerWidth = track.parentElement.offsetWidth;
      const card = allCards[index];
      if (!card) return 0;
      return containerWidth / 2 - (card.offsetLeft + card.offsetWidth / 2);
    };

    // Fix #10: void offsetWidth instead of getBoundingClientRect for style flush
    const goTo = (index, animate = true) => {
      currentIndex = index;
      const offset = calcOffset(index);
      if (animate) {
        track.style.transition = 'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)';
        track.style.transform = `translateX(${offset}px)`;
        updateActiveClass();
      } else {
        // Suppress ALL transitions (track + cards + pseudo-elements) during the
        // silent clone→real jump so is-active changes don't re-trigger scale animations.
        track.style.transition = 'none';
        track.classList.add('is-jumping');
        void track.offsetWidth; // flush: browser commits transition:none on all children
        track.style.transform = `translateX(${offset}px)`;
        updateActiveClass();
        void track.offsetWidth; // flush: browser commits the is-active state before re-enabling
        track.classList.remove('is-jumping');
        track.style.transition = '';
      }
    };

    const updateActiveClass = () => {
      allCards.forEach((card, i) => {
        card.classList.toggle('is-active', i === currentIndex);
      });
    };

    const handleInfiniteEdge = () => {
      const onEnd = () => {
        track.removeEventListener('transitionend', onEnd);
        isTransitioning = false;
        if (currentIndex < CLONE_COUNT) {
          goTo(currentIndex + totalReal, false);
        } else if (currentIndex >= CLONE_COUNT + totalReal) {
          goTo(currentIndex - totalReal, false);
        }
      };
      track.addEventListener('transitionend', onEnd);
    };

    // Slide directly to any index in one smooth animation (used by nav
    // arrows for ±1 and by card clicks that can be several positions away).
    const slideTo = (index) => {
      if (isTransitioning || index === currentIndex) return;
      isTransitioning = true;
      goTo(index);
      handleInfiniteEdge();
    };

    const prev = () => slideTo(currentIndex - 1);
    const next = () => slideTo(currentIndex + 1);

    const handleAddToCart = async (btn) => {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      const originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = loaderHTML;
      try {
        const sectionId = document.querySelector('cart-drawer')?.dataset?.sectionId;
        const sections = sectionId ? [sectionId] : [];
        const formData = new FormData();
        formData.append('id', parseInt(variantId, 10));
        formData.append('quantity', 1);
        const data = await CartAPI.add(formData, sections);
        const optimisticCount = parseInt(document.querySelector('[data-cart-count]')?.dataset?.cartCount ?? '0', 10) + 1;
        publish(PUB_SUB_EVENTS.cartAdd, {
          source: 'reel-carousel',
          sections: data.sections,
          item_count: optimisticCount,
        });
        document.querySelector('cart-drawer')?.open();
        CartAPI.get().then(cart => updateCartCount(cart.item_count)).catch(() => {});
      } catch (err) {
        console.error('[reel-carousel] add to cart failed', err);
      }
      btn.disabled = false;
      btn.innerHTML = originalHTML;
    };

    function lockBodyScroll() {
      const scrollY = window.pageYOffset;
      document.body.dataset.rcScrollY = scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.documentElement.classList.add('rc-modal-open');
      document.body.classList.add('rc-modal-open');
    }

    function unlockBodyScroll() {
      const savedY = parseInt(document.body.dataset.rcScrollY || '0', 10);
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      delete document.body.dataset.rcScrollY;
      document.documentElement.classList.remove('rc-modal-open');
      document.body.classList.remove('rc-modal-open');
      window.scrollTo(0, savedY);
    }

    function openModal(modalId) {
      const modalEl = wrapper.querySelector(`[data-rc-modal="${modalId}"]`);
      if (!modalEl) return;
      modalEl.removeAttribute('hidden');
      const video = modalEl.querySelector('.reel-carousel__modal-video');
      if (video) {
        const src = video.dataset.videoSrc;
        if (src) {
          video.src = src;
          video.currentTime = 0;
          video.muted = false;
          video.play().catch(() => {});
        }
      }
      lockBodyScroll();
    }

    function closeModal(modalId) {
      const modalEl = wrapper.querySelector(`[data-rc-modal="${modalId}"]`);
      if (!modalEl) return;
      modalEl.setAttribute('hidden', '');
      const video = modalEl.querySelector('.reel-carousel__modal-video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      unlockBodyScroll();
    }

    const bindEvents = () => {
      if (navPrev) navPrev.addEventListener('click', prev);
      if (navNext) navNext.addEventListener('click', next);

      track.addEventListener('click', (e) => {
        if (e.target.closest('[data-rc-play]') || e.target.closest('[data-rc-atc]') || e.target.closest('[data-rc-variant-pill]') || e.target.closest('[data-rc-swatch-dropdown]')) return;
        const card = e.target.closest('[data-rc-card]');
        if (!card) return;
        const idx = allCards.indexOf(card);
        if (idx === -1 || idx === currentIndex) return;
        e.stopPropagation();
        // Slide the clicked card straight to center, however far it is.
        slideTo(idx);
      });

      // Fix #2: single delegated handler replaces 8 separate document click listeners
      document.addEventListener('click', (e) => {
        // Mute toggle — checked first (Fix #8: scoped to wrapper videos only)
        const muteBtn = e.target.closest('[data-rc-mute]');
        if (muteBtn) {
          // Use closest card, not closest modal — in vertical mode all cards live inside
          // masterModal so closest('[data-rc-modal]') always finds card 1's video.
          const modalCard = muteBtn.closest('.reel-carousel__modal-card');
          const video = modalCard ? modalCard.querySelector('.reel-carousel__modal-video') : null;
          if (video) {
            const wasMuted = video.muted;
            wrapper.querySelectorAll('video').forEach(v => { v.muted = true; });
            video.muted = !wasMuted;
            modalMuted = video.muted;
            const iconOn = muteBtn.querySelector('.reel-carousel__icon-unmuted');
            const iconOff = muteBtn.querySelector('.reel-carousel__icon-muted');
            if (iconOn) iconOn.style.display = video.muted ? 'none' : 'block';
            if (iconOff) iconOff.style.display = video.muted ? 'block' : 'none';
          }
          return;
        }

        // Play button (covers the whole card video area)
        const playBtn = e.target.closest('[data-rc-play]');
        if (playBtn) {
          const card = playBtn.closest('[data-rc-card]');
          if (!card) return;
          const modalId = playBtn.dataset.rcPlay;
          // Active (centered) card: open the modal straight away.
          if (card.classList.contains('is-active')) {
            if (modalId) modal.open(modalId);
            return;
          }
          // Side card: smoothly slide it to center first, then open the
          // modal once the slide transition finishes.
          const idx = allCards.indexOf(card);
          if (idx === -1 || idx === currentIndex) return;
          slideTo(idx);
          if (modalId) {
            const onSlideEnd = (ev) => {
              if (ev.target !== track || ev.propertyName !== 'transform') return;
              track.removeEventListener('transitionend', onSlideEnd);
              modal.open(modalId);
            };
            track.addEventListener('transitionend', onSlideEnd);
          }
          return;
        }

        // Modal close
        const closeEl = e.target.closest('[data-rc-modal-close]');
        if (closeEl) {
          modal.close(closeEl.dataset.rcModalClose);
          return;
        }

        // Modal variant pill
        const modalPill = e.target.closest('[data-rc-modal-variant-pill]');
        if (modalPill) {
          const modalCard = modalPill.closest('.reel-carousel__modal-card');
          if (modalCard) {
            modalCard.querySelectorAll('[data-rc-modal-variant-pill]').forEach(p => p.classList.remove('is-selected'));
            modalPill.classList.add('is-selected');
            const priceEl = modalCard.querySelector('[data-rc-modal-price]');
            if (priceEl && modalPill.dataset.price) priceEl.textContent = modalPill.dataset.price;
            const compareEl = modalCard.querySelector('[data-rc-modal-compare-price]');
            if (compareEl) {
              const price = parsePrice(modalPill.dataset.price);
              const comparePrice = parsePrice(modalPill.dataset.comparePrice);
              if (comparePrice > price) {
                compareEl.textContent = modalPill.dataset.comparePrice;
                compareEl.removeAttribute('hidden');
              } else {
                compareEl.setAttribute('hidden', '');
              }
            }
            const atcBtn = modalCard.querySelector('[data-rc-modal-atc]');
            if (atcBtn && modalPill.dataset.variantId) atcBtn.dataset.variantId = modalPill.dataset.variantId;
          }
          return;
        }

        // Swatch trigger
        const trigger = e.target.closest('[data-rc-swatch-trigger]');
        if (trigger) {
          e.stopPropagation();
          const dropdown = trigger.closest('[data-rc-swatch-dropdown]');
          if (!dropdown) return;
          document.querySelectorAll('[data-rc-swatch-dropdown].is-open').forEach(d => {
            if (d !== dropdown) d.classList.remove('is-open');
          });
          dropdown.classList.toggle('is-open');
          return;
        }

        // Swatch option
        const option = e.target.closest('[data-rc-swatch-option]');
        if (option) {
          e.stopPropagation();
          const dropdown = option.closest('[data-rc-swatch-dropdown]');
          if (!dropdown) return;
          dropdown.classList.remove('is-open');

          const variantId = option.dataset.variantId;
          const productId = dropdown.dataset.productId;
          const inModal = !!option.closest('[data-rc-modal]');
          const isAvailable = option.dataset.available !== 'false';

          // A product's real card and its edge clones share a product-id.
          // Apply the selection to every card dropdown for this product so the
          // clone and real stay in sync when the infinite loop swaps them.
          // In the modal, only the modal's own dropdown is touched.
          const dropdowns = inModal
            ? [dropdown]
            : [...track.querySelectorAll(`[data-rc-swatch-dropdown][data-product-id="${productId}"]`)];

          dropdowns.forEach(dd => {
            dd.querySelectorAll('[data-rc-swatch-option]').forEach(o => {
              o.classList.toggle('is-selected', o.dataset.variantId === variantId);
            });
            const textEl = dd.querySelector('[data-rc-swatch-text]');
            if (textEl) textEl.textContent = option.dataset.display || '';
            const context = dd.closest('[data-rc-card]') || dd.closest('[data-rc-modal]');
            if (!context) return;
            const priceEl = context.querySelector('[data-rc-price], [data-rc-modal-price]');
            if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;
            const compareEl = context.querySelector('[data-rc-compare-price], [data-rc-modal-compare-price]');
            if (compareEl) {
              const price = parsePrice(option.dataset.price);
              const comparePrice = parsePrice(option.dataset.comparePrice);
              if (comparePrice > price) {
                compareEl.textContent = option.dataset.comparePrice;
                compareEl.removeAttribute('hidden');
              } else {
                compareEl.setAttribute('hidden', '');
              }
            }
          });

          if (productId && variantId) {
            document.querySelectorAll(`[data-rc-atc][data-product-id="${productId}"], [data-rc-modal-atc][data-product-id="${productId}"]`).forEach(btn => {
              btn.dataset.variantId = variantId;
              btn.disabled = !isAvailable;
            });
          }
          return;
        }

        // Modal ATC
        const modalAtcBtn = e.target.closest('[data-rc-modal-atc]');
        if (modalAtcBtn) {
          handleAddToCart(modalAtcBtn);
          return;
        }

        // Close swatch dropdown on outside click
        if (!e.target.closest('[data-rc-swatch-dropdown]')) {
          document.querySelectorAll('[data-rc-swatch-dropdown].is-open').forEach(d => d.classList.remove('is-open'));
        }
      });

      let touchStartX = 0;
      let touchStartY = 0;
      track.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      track.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) < 30 || Math.abs(dy) > Math.abs(dx)) return;
        if (dx < 0) next(); else prev();
      }, { passive: true });

      let wheelLocked = false;
      let lastWheelTime = 0;
      track.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaY) >= Math.abs(e.deltaX)) return;
        e.preventDefault();
        const delta = e.deltaX;
        if (Math.abs(delta) < 12) return;
        const now = Date.now();
        if (wheelLocked || now - lastWheelTime < 650) return;
        wheelLocked = true;
        lastWheelTime = now;
        if (delta > 0) next(); else prev();
        track.addEventListener('transitionend', function unlock() {
          track.removeEventListener('transitionend', unlock);
          wheelLocked = false;
        });
      }, { passive: false });

      wrapper.setAttribute('tabindex', '0');
      wrapper.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') prev();
        else if (e.key === 'ArrowRight') next();
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => goTo(currentIndex, false), 250);
      });

      // Card variant pills (scoped to wrapper, not document)
      wrapper.addEventListener('click', (e) => {
        const pill = e.target.closest('[data-rc-variant-pill]');
        if (!pill) return;
        e.stopPropagation();
        const card = pill.closest('[data-rc-card]');
        if (!card) return;
        card.querySelectorAll('[data-rc-variant-pill]').forEach(p => p.classList.remove('is-selected'));
        pill.classList.add('is-selected');
        const priceEl = card.querySelector('[data-rc-price]');
        if (priceEl && pill.dataset.price) priceEl.textContent = pill.dataset.price;
        const compareEl = card.querySelector('[data-rc-compare-price]');
        if (compareEl) {
          const price = parsePrice(pill.dataset.price);
          const comparePrice = parsePrice(pill.dataset.comparePrice);
          if (comparePrice > price) {
            compareEl.textContent = pill.dataset.comparePrice;
            compareEl.removeAttribute('hidden');
          } else {
            compareEl.setAttribute('hidden', '');
          }
        }
        const atcBtn = card.querySelector('[data-rc-atc]');
        if (atcBtn && pill.dataset.variantId) atcBtn.dataset.variantId = pill.dataset.variantId;
      });

      // Card ATC (scoped to wrapper)
      wrapper.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-rc-atc]');
        if (!btn) return;
        e.stopPropagation();
        await handleAddToCart(btn);
      });
    };

    const initVerticalModal = () => {
      const modals = [...wrapper.querySelectorAll('[data-rc-modal]')];
      if (modals.length === 0) return;

      const getVH = () => window.visualViewport?.height ?? window.innerHeight;

      const scrollContainer = document.createElement('div');
      scrollContainer.className = 'reel-carousel__modal-scroll-container';

      const items = [];
      const videoCache = []; // Fix #9: cache video elements, avoid per-scroll queries

      modals.forEach((modalEl) => {
        const card = modalEl.querySelector('.reel-carousel__modal-card');
        if (!card) return;
        const item = document.createElement('div');
        item.className = 'reel-carousel__modal-scroll-item';
        item.appendChild(card);
        scrollContainer.appendChild(item);
        items.push(item);
        videoCache.push(item.querySelector('.reel-carousel__modal-video'));
      });

      const masterModal = modals[0];
      masterModal.appendChild(scrollContainer);
      modals.slice(1).forEach(m => m.remove());

      const applyHeight = () => {
        const vh = getVH();
        masterModal.style.height = `${vh}px`;
        scrollContainer.style.height = `${vh}px`;
        items.forEach(item => {
          item.style.height = `${vh}px`;
          const card = item.querySelector('.reel-carousel__modal-card');
          if (card) {
            card.style.height = `${vh}px`;
            card.style.minHeight = `${vh}px`;
          }
        });
      };

      const pauseAllVideos = () => {
        videoCache.forEach(v => v && v.pause());
      };

      const playVideoAt = (index) => {
        pauseAllVideos();
        const video = videoCache[index];
        if (!video) return;
        if (!video.src && video.dataset.videoSrc) video.src = video.dataset.videoSrc;
        video.currentTime = 0;
        video.muted = modalMuted;
        video.play().catch(() => {});
        // Sync the mute button icon for the card now playing
        const card = video.closest('.reel-carousel__modal-card');
        if (card) {
          const btn = card.querySelector('[data-rc-mute]');
          if (btn) {
            const iconOn = btn.querySelector('.reel-carousel__icon-unmuted');
            const iconOff = btn.querySelector('.reel-carousel__icon-muted');
            if (iconOn) iconOn.style.display = modalMuted ? 'none' : 'block';
            if (iconOff) iconOff.style.display = modalMuted ? 'block' : 'none';
          }
        }
      };

      let scrollTimer;
      scrollContainer.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const index = Math.round(scrollContainer.scrollTop / getVH());
          playVideoAt(index);
        }, 100);
      });

      let vpResizeHandler = null;
      let vpScrollHandler = null;

      modal.open = (modalId) => {
        const index = parseInt(modalId, 10) - 1;
        masterModal.style.visibility = 'hidden';
        masterModal.removeAttribute('hidden');
        lockBodyScroll();

        vpResizeHandler = applyHeight;
        vpScrollHandler = applyHeight;
        window.addEventListener('resize', applyHeight);
        window.addEventListener('orientationchange', applyHeight);
        window.visualViewport?.addEventListener('resize', vpResizeHandler);
        window.visualViewport?.addEventListener('scroll', vpScrollHandler);

        setTimeout(() => {
          requestAnimationFrame(() => {
            applyHeight();
            scrollContainer.scrollTop = index * getVH();
            masterModal.style.visibility = 'visible';
            setTimeout(() => playVideoAt(index), 150);
          });
        }, 220);
      };

      modal.close = () => {
        masterModal.setAttribute('hidden', '');
        pauseAllVideos();
        window.removeEventListener('resize', applyHeight);
        window.removeEventListener('orientationchange', applyHeight);
        if (vpResizeHandler) window.visualViewport?.removeEventListener('resize', vpResizeHandler);
        if (vpScrollHandler) window.visualViewport?.removeEventListener('scroll', vpScrollHandler);
        vpResizeHandler = null;
        vpScrollHandler = null;
        unlockBodyScroll();
      };
    };

    const preloadModalVideos = () => {
      const allModalVideos = [...wrapper.querySelectorAll('.reel-carousel__modal-video')];
      if (!allModalVideos.length) return;
      const realCards = allCards.filter(c => c.getAttribute('aria-hidden') !== 'true');
      if (!realCards.length) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          const idx = realCards.indexOf(entry.target);
          if (idx === -1) return;
          const video = allModalVideos[idx];
          if (video && !video.src && video.dataset.videoSrc) {
            video.src = video.dataset.videoSrc;
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0 });
      realCards.forEach(card => observer.observe(card));
    };

    // Fix #4: ResizeObserver replaces requestAnimationFrame polling loop
    const initSlider = () => {
      const realCards = [...track.querySelectorAll('[data-rc-card]')];
      totalReal = realCards.length;
      if (totalReal === 0) return;

      cloneEdges(realCards);
      allCards = [...track.children];

      currentIndex = CLONE_COUNT;
      goTo(currentIndex, false);

      wrapper.classList.add('reel-carousel--loaded');
      if (skeleton) skeleton.setAttribute('hidden', '');

      bindEvents();
      if (modalStyle === 'vertical') initVerticalModal();
      preloadModalVideos();
    };

    const ro = new ResizeObserver((entries, observer) => {
      if (entries[0].contentRect.width >= 50) {
        observer.disconnect();
        initSlider();
      }
    });

    // Only start observing track width (and therefore init the slider) once
    // the section is near the viewport. The section is 2900px+ below fold on
    // the homepage — running ResizeObserver + DOM cloning + 10 event listeners
    // at DOMContentLoaded wastes main-thread time before the user can see it.
    const io = new IntersectionObserver((ioEntries, ioObs) => {
      if (!ioEntries[0].isIntersecting) return;
      ioObs.disconnect();
      ro.observe(track);
    }, { rootMargin: '300px 0px' });
    io.observe(wrapper);
  });
})();
